import { TYPE_TX } from "./transactionHistoryConstants";

export const getTransactionIconProps = ({ side, type }) => {
    let iconProps;
    if ([TYPE_TX.BONUS_CREDIT, TYPE_TX.BONUS_REDUCE, TYPE_TX.BONUS_REFUND].includes(type)) {
        iconProps = { name: 'IcCoupon' };
    } else if (side === 'up' || type === TYPE_TX.DEPOSIT) {
        iconProps = { name: 'IcChevronRight', style: {color: '#0ABC6F'} }
    } else {
        iconProps = { name: 'IcChevronLeft', style: {color: '#FF646C'} }
    }
    return iconProps;
}

export const getTransactionTypeText = ({ side, type, getLangPath }) => {
    let text;
    if (type) {
        text = getLangPath(`transactions.type.${type}`);
    } else {
        text = getLangPath(`transactions.type.${side === 'up' ? 'deposit' : 'withdrawal'}`);
    }
    return text;
}

export const getTransactionTypeDescriptionText = ({side, type, getLangPath}) => {
    if (type) {
        const typeDescriptionKey = `transactions.type_description.${type}`;
        const text = getLangPath(typeDescriptionKey);
        if (text !== typeDescriptionKey) {
            return text;
        }
    }
    return getTransactionTypeText({side, type, getLangPath});
}
